import React from "react";
import { GameSettingBaseProps } from "components/common/GameSettingModal";
import { useTranslation } from "react-i18next";
import SocketService from "../../network/SocketService";
import SocketProtocol from "../../network/SocketProtocol";

// WaitingRoom용 설정 컴포넌트 (기본 게임 설정만)
interface WaitingRoomSettingProps extends GameSettingBaseProps {}

// WaitingRoom용 간단한 설정 컴포넌트
const RoleDistributorGameSettingBody: React.FC<WaitingRoomSettingProps> = ({
  setGameSetting,
  roomParams,
  aiCount,
}) => {
  const { t } = useTranslation();

  const handleAI = (add: boolean) => {
    SocketService.getInstance().emit(
      SocketProtocol.ADD_AI_PLAYER,
      roomParams.product.id,
      roomParams.room.roomName,
      add
    );
  };

  return (
    <div className="space-y-4">
      {/* AI 추가 설정 */}
      <div className="flex items-center justify-center gap-2">
        <div className="text-white font-medium text-sm">{t("addAI")}</div>
        <div className="flex items-center gap-1 px-2">
          <button
            className="!w-[32px] text-white text-lg"
            onClick={() => handleAI(false)}
            disabled={aiCount <= 0}
          >
            –
          </button>
          <span className="text-white min-w-[20px] text-center">{aiCount}</span>
          <button
            className="!w-[32px] text-white text-lg"
            onClick={() => handleAI(true)}
          >
            +
          </button>
        </div>
      </div>

      <div className="text-gray-400 text-sm text-center">
        {t("RoleDistributor.gameStartInfo")}
      </div>
    </div>
  );
};

export default RoleDistributorGameSettingBody;
